/**
 * DB 열람가 산출
 * - 본사 site_settings 가격표 기반 DB 1건당 열람 수수료(=제휴업체 결제액) 계산
 * - 정책: 열람가는 모든 카테고리 단일 고정값 (unit)
 *   · 이사: movingTiers[type].unit
 *   · 청소: cleaningPrice.unit
 *   · 인터넷TV: internetPrice.unit
 *   · 인테리어: interiorPrice.unit
 *   · 기타: industryDefaults[category].partnerRequest fallback
 * - 평당 산출(평수×단가)은 완료가(미수금)에만 적용 — calcCompletionPrice 참조
 */
import { getSiteSettings } from './settingsService';

// 신청 폼의 moving_type 값 → DbPricing 매트릭스 키 매핑
const MOVING_TIER_MAP = {
  cargo: 'van',
  van: 'van',
  half_pack: 'semi_pack',
  semi_pack: 'semi_pack',
  semi: 'semi_pack',
  semi_package: 'semi_pack',
  full_pack: 'pack',
  pack: 'pack',
  package: 'pack',
  normal: 'normal',
  general: 'normal',
  regular: 'normal',
  ordinary: 'normal',
  simple: 'normal',
};

export const computeDbPrice = (settings, sr /* customer 인자는 더 이상 사용 X */) => {
  if (!settings || !sr) return 0;
  const cat = sr.category;
  if (!cat) return 0;

  if (cat === 'moving') {
    const tierKey = MOVING_TIER_MAP[sr.moving_type] || 'normal';
    return Number(settings.movingTiers?.[tierKey]?.unit) || 0;
  }
  if (cat === 'cleaning') {
    return Number(settings.cleaningPrice?.unit) || 0;
  }
  if (cat === 'internet_tv') {
    // internet_type 이 'internet_only' 면 internetPriceOnly 사용
    const isOnly = sr.internet_type === 'internet_only';
    const priceObj = isOnly ? settings.internetPriceOnly : settings.internetPrice;
    return Number(priceObj?.unit) || Number(settings.internetPrice?.unit) || 0;
  }
  if (cat === 'interior') {
    return Number(settings.interiorPrice?.unit) || 0;
  }

  // aircon / water_purifier / kiosk
  const ind = (settings.industryDefaults || []).find((row) => row.key === cat);
  return Number(ind?.partnerRequest) || 0;
};

export const computeDbPriceForRequest = async (sr) => {
  const settings = await getSiteSettings();
  return computeDbPrice(settings, sr);
};

// 완료가(미수금) 가 평당 산출되는 카테고리 — 카드 평수 표시 정책에 사용
export const isPerPyeongCategory = (cat) => cat === 'moving' || cat === 'cleaning';
